// AWS configuration
export const S3_BUCKET_NAME = 'acolyte-images';
export const AWS_REGION = 'eu-central-1';

// Database configurations
export const TABLE_USER = "User";
export const TABLE_SESSION = 'Acolyte_Session';
export const TABLE_MOBILE_SESSION = 'Acolyte_Mobile_Session';
export const TABLE_EMAIL_VERIFICATION = 'Acolyte_Email_Verification';
export const TABLE_AMCR_CACHE = 'Acolyte_AMCR_Cache';

// Security constants
export const JWT_SECRET = 'd3860b4c-6df7-4fa4-bd34-4de82b437608';

// App origin (used to build links inside outgoing emails)
export const PRODUCTION_APP_ORIGIN = 'https://acolyte.cz';
export const APP_ORIGIN =
  process.env.NODE_ENV === 'production'
    ? PRODUCTION_APP_ORIGIN
    : process.env.APP_ORIGIN || 'http://localhost:3000';

// Email configuration
export const EMAIL_FROM = process.env.EMAIL_FROM || 'no-reply@acolyte.cz';
export const EMAIL_FROM_NAME = process.env.EMAIL_FROM_NAME || 'Acolyte';
export const EMAIL_LOGO_URL = process.env.EMAIL_LOGO_URL || 'https://acolyte-images.s3.eu-central-1.amazonaws.com/logo.png';
export const CONTENT_REPORT_EMAIL =
  process.env.CONTENT_REPORT_EMAIL || 'support@acolyte.cz';

// Token / request lifetimes
export const RESET_TTL_MINUTES = 120;
export const VERIFY_TTL_MINUTES = 24 * 60;
export const VERIFY_CODE_TTL_MINUTES = 30;

// Cloudflare Worker that reverse-proxies + edge-caches upstream tile servers
export const TILE_CDN = 'https://acolyte-tiles.jurajhrib.workers.dev';
